import axios from "axios";

const SERVER = process.env.REACT_APP_SERVER_DOMAIN || "http://localhost:8000";

/**
 * GET /api/integrations/instagram/login — asks the backend to build the
 * Instagram authorization URL. The frontend never constructs OAuth URLs itself.
 * @returns {Promise<string>} authorizationUrl
 */
export async function fetchInstagramAuthorizationUrl(workspaceId, token) {
  const response = await axios.get(
    `${SERVER}/api/integrations/instagram/login`,
    {
      params: { workspaceId },
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data?.data?.authorizationUrl;
}

/**
 * GET /api/integrations/instagram/profile — retrieves the connected
 * workspace's Instagram profile (refreshed from Instagram directly).
 * @returns {Promise<object>} profile data
 */
export async function fetchInstagramProfile(workspaceId, token) {
  const response = await axios.get(
    `${SERVER}/api/integrations/instagram/profile`,
    {
      params: { workspaceId },
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data?.data;
}

/**
 * POST /api/integrations/instagram/disconnect — removes the workspace's Instagram connection.
 */
export async function disconnectInstagram(workspaceId, token) {
  const response = await axios.post(
    `${SERVER}/api/integrations/instagram/disconnect`,
    { workspaceId },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}
